import { ParamIds, Places } from 'src/Constants'
import { MainKeys } from 'src/main/Main.keys'

export class RegraFormKeys extends MainKeys {
    get place() {
        return Places.regraForm
    }

    public get regraId() {
        return this._intent.getParameterAsNumber(ParamIds.regraFormId)
    }

    public set regraId(value: number | undefined) {
        this._intent.setParameter(ParamIds.regraFormId, value)
    }

    public get analiseId() {
        return this._intent.getParameterAsNumber(ParamIds.analiseFormId)
    }

    public set analiseId(value: number | undefined) {
        this._intent.setParameter(ParamIds.analiseFormId, value)
    }
}
export default RegraFormKeys
